//bridge abi
import { abi as BSCBridge } from "./abi/BSCBridge";
import { abi as ETHBridge } from "./abi/ETHBridge";

//token abi
import { abi as bscMContent } from "./abi/bscMContent";
import { abi as ethMContent } from "./abi/ethMContent";

//token address
//previous token addresses
// export const TOKEN_ERC20 = "0x51a93C27413Fe8ec3B1f640c0562e2Aa76212281";
// export const TOKEN_BEP20 = "0x4fE93568293ea0E6f89bB0A620aBED59898a8972";

// export const TOKEN_ERC20 = "0xbAdED289919482C0AdAEC28AEE95FB005778D0bB";

// rinkeby and bsctestnet tokens addresses
// export const TOKEN_ERC20 = "0x3c296e2e9B7cc4967B4776BEEF50133Db0002313";
// export const TOKEN_BEP20 = "0xdDB0024B85C4F4A327432D282FEcD7ab226f4cBE";

// mainnet tokens addresses
export const TOKEN_ERC20 = "0xd3c51de3e6dd9b53d7f37699afb3ee3bf9b9b3f4";
export const TOKEN_BEP20 = "0x799e1cf88a236e42b4a87c544a22a94ae95a6910";

//bridge address
// previous bridge address
// export const BRIDGE_ERC20 = "0x5bC4beA0696B807f6F2e9d2d5F596b55bAAf22E3";
// export const BRIDGE_BEP20 = "0x5f4920284438b016AB055300c74dd7903e3BBc04";

// export const BRIDGE_ERC20 = "0x50A9020Ba7c8A219d5736F4cCB1fd9F07c1C436D";
// export const BRIDGE_ERC20 = "0x3bC419e0d22c2b98024467d9808206d142e8529D";
// export const BRIDGE_BEP20 = "0x8f22d7D41475453e131c0Ad4E6a9EB146B5085C0";

//mainnet Bridge addresses
export const BRIDGE_ERC20 = "0xa4c5f00622e2958a10bf82d461a48ba78eb32580";
export const BRIDGE_BEP20 = "0x2C0D93CbcaFcd531DE0F7c649e3bc22b9a95A143";

//// rinkeby and bsctestnet Bridge ABIS
// export const BRIDGE_BEP20_ABI = BSCBridge;
// export const BRIDGE_ERC20_ABI = ETHBridge;

//mainnet Bridge ABIS
export const BRIDGE_BEP20_ABI = BSCBridge;
export const BRIDGE_ERC20_ABI = ETHBridge;

// rinkeby and bsctestnet Token ABIS
// export const TOKEN_BEP20_ABI = bscMContent;
// export const TOKEN_ERC20_ABI = ethMContent;

//mainnet token ABIS
export const TOKEN_BEP20_ABI = bscMContent;
export const TOKEN_ERC20_ABI = ethMContent;

export const ETHERSCAN_ACCOUNT_LINK_RINKBY = "https://rinkeby.etherscan.io/address/";

export const ETHERSCAN_ACCOUNT_LINK = "https://etherscan.io/address/";

// export const mContentLink = "localhost:3000"
export const mContentLink = "https://bridge.mcontent.net/"


export const backendURL = 'https://bridge-server.mcontent.net/';

// export const backendURL = 'http://3.230.140.68:3000/';

export const bscScanExplorerURL = "https://bscscan.com/tx/";

export const etherScanExplorerURL = "https://etherscan.io/tx/";

//index 0 will be ethereum and index 1 will be binance
export const supportedChains = [1, 56];

export const URL_INFURA_MAINNET =
  "https://speedy-nodes-nyc.moralis.io/0676906f814449c55f778a3a/eth/mainnet/archive/ws";

export const URL_INFURA_RINKEBY =
  "https://rinkeby.infura.io/v3/3677788ecbb042f3b941ddd26dc8fc08";

export const URL_INFURA_BSCTESTNET = "https://data-seed-prebsc-1-s1.binance.org:8545/";

export const URL_INFURA_BSCMAINNET = "https://speedy-nodes-nyc.moralis.io/0676906f814449c55f778a3a/bsc/mainnet";